import {
  CREATE_REPORT_CUSTOM_VIEW,
  CREATE_REPORT_CUSTOM_VIEW_SUCCESS,
  CREATE_REPORT_CUSTOM_VIEW_FAILURE,
  FETCH_REPORT_CUSTOM_VIEW,
  FETCH_REPORT_CUSTOM_VIEW_SUCCESS,
  FETCH_REPORT_CUSTOM_VIEW_FAILURE,
  SELECT_REPORT_CUSTOM_VIEW,
  SELECT_REPORT_CUSTOM_VIEW_SUCCESS,
  SELECT_REPORT_CUSTOM_VIEW_FAILURE,
  DELETE_REPORT_CUSTOM_VIEW,
  DELETE_REPORT_CUSTOM_VIEW_SUCCESS,
  DELETE_REPORT_CUSTOM_VIEW_FAILURE,
  RESET_REPORT_CUSTOM_VIEW,
  FETCH_REPORT_CUSTOM_VIEW_BY_ID,
  FETCH_REPORT_CUSTOM_VIEW_BY_ID_FAILURE,
  FETCH_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS,
  EDIT_REPORT_CUSTOM_VIEW_BY_ID,
  EDIT_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS,
  EDIT_REPORT_CUSTOM_VIEW_BY_ID_FAILURE,
  UNSELECT_REPORT_CUSTOM_VIEW,
  UNSELECT_REPORT_CUSTOM_VIEW_SUCCESS,
  UNSELECT_REPORT_CUSTOM_VIEW_FAILURE,
  FETCH_JOB_UNIVERSAL_REPORT_COUNT,
  FETCH_JOB_UNIVERSAL_REPORT_COUNT_SUCCESS,
  FETCH_JOB_UNIVERSAL_REPORT_COUNT_FAILURE,
  FETCH_JOB_UNIVERSAL_REPORT_LISTING,
  FETCH_JOB_UNIVERSAL_REPORT_LISTING_SUCCESS,
  FETCH_JOB_UNIVERSAL_REPORT_LISTING_FAILURE,
  SET_DEFAULT_CUSTOM_VIEW,
  DELETE_DEFAULT_CUSTOM_VIEW,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING_SUCCESS,
  FETCH_JOB_UNIVERSAL_REPOR_JOBT_LISTING_FAILURE,
  SET_JOB_DEFAULT_CUSTOM_VIEW,
  DELETE_JOB_DEFAULT_CUSTOM_VIEW,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_FAILURE,
  FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_SUCCESS,
} from "./actionTypes";

// Create Report Custom View
export const createReportCustomView = (reportCustomViewRequest) => ({
  type: CREATE_REPORT_CUSTOM_VIEW,
  payload: reportCustomViewRequest,
});

export const createReportCustomViewSuccess = (reportCustomView, viewType) => ({
  type: CREATE_REPORT_CUSTOM_VIEW_SUCCESS,
  payload: {
    reportCustomView,
    viewType,
  },
});

export const createReportCustomViewFailure = (error) => ({
  type: CREATE_REPORT_CUSTOM_VIEW_FAILURE,
  payload: error,
});

// Fetch Report Custom Views
export const fetchReportCustomView = (viewType) => ({
  type: FETCH_REPORT_CUSTOM_VIEW,
  payload: viewType,
});

export const fetchReportCustomViewSuccess = (reportCustomViews, viewType) => ({
  type: FETCH_REPORT_CUSTOM_VIEW_SUCCESS,
  payload: { reportCustomViews, viewType },
});

export const fetchReportCustomViewFailure = (error) => ({
  type: FETCH_REPORT_CUSTOM_VIEW_FAILURE,
  payload: error,
});

export const resetReportCustomView = () => ({
  type: RESET_REPORT_CUSTOM_VIEW,
});

// Select Report Custom View
export const selectReportCustomView = (reportCustomViewRequest) => ({
  type: SELECT_REPORT_CUSTOM_VIEW,
  payload: reportCustomViewRequest,
});

export const selectReportCustomViewSuccess = (reportCustomView, viewType) => ({
  type: SELECT_REPORT_CUSTOM_VIEW_SUCCESS,
  payload: { reportCustomView, viewType },
});

export const selectReportCustomFailure = (error) => ({
  type: SELECT_REPORT_CUSTOM_VIEW_FAILURE,
  payload: error,
});

// Delete Report Custom View
export const deleteReportCustomView = (reportCustomViewId) => ({
  type: DELETE_REPORT_CUSTOM_VIEW,
  payload: reportCustomViewId,
});

export const deleteReportCustomViewSuccess = (reportCustomViewId) => ({
  type: DELETE_REPORT_CUSTOM_VIEW_SUCCESS,
  payload: reportCustomViewId,
});

export const deleteReportCustomViewFailure = (error) => ({
  type: DELETE_REPORT_CUSTOM_VIEW_FAILURE,
  payload: error,
});

export const fetchReportCustomViewById = (reportCustomViewId) => ({
  type: FETCH_REPORT_CUSTOM_VIEW_BY_ID,
  payload: reportCustomViewId,
});

export const fetchReportCustomViewByIdSuccess = (reportCustomView) => ({
  type: FETCH_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS,
  payload: reportCustomView,
});

export const fetchReportCustomViewByIdFailure = (error) => ({
  type: FETCH_REPORT_CUSTOM_VIEW_BY_ID_FAILURE,
  payload: error,
});

export const editReportCustomViewById = (reportCustomViewRequest) => ({
  type: EDIT_REPORT_CUSTOM_VIEW_BY_ID,
  payload: reportCustomViewRequest,
});

export const editReportCustomViewByIdSuccess = (reportCustomView) => ({
  type: EDIT_REPORT_CUSTOM_VIEW_BY_ID_SUCCESS,
  payload: reportCustomView,
});

export const editReportCustomViewByIdFailure = (error) => ({
  type: EDIT_REPORT_CUSTOM_VIEW_BY_ID_FAILURE,
  payload: error,
});

export const unselectReportCustomView = (viewType) => ({
  type: UNSELECT_REPORT_CUSTOM_VIEW,
  payload: viewType,
});

export const unselectReportCustomViewSuccess = (viewType) => ({
  type: UNSELECT_REPORT_CUSTOM_VIEW_SUCCESS,
  payload: viewType,
});

export const unselectReportCustomViewFailure = (error) => ({
  type: UNSELECT_REPORT_CUSTOM_VIEW_FAILURE,
  payload: error,
});

// Candidate Static Report Count
export const fetchJobUniversalReportCount = (countRequest) => ({
  type: FETCH_JOB_UNIVERSAL_REPORT_COUNT,
  payload: countRequest,
});

export const fetchJobUniversalReportCountSuccess = (
  candidateStaticReportCount
) => ({
  type: FETCH_JOB_UNIVERSAL_REPORT_COUNT_SUCCESS,
  payload: candidateStaticReportCount,
});

export const fetchJobUniversalReportCountFailure = (error) => ({
  type: FETCH_JOB_UNIVERSAL_REPORT_COUNT_FAILURE,
  payload: error,
});

// Candidate Static Report Listing
export const fetchJobUniversalReportListing = (
  candidateStaticReportListingRequest
) => ({
  type: FETCH_JOB_UNIVERSAL_REPORT_LISTING,
  payload: candidateStaticReportListingRequest,
});

export const fetchJobUniversalReportListingSuccess = (
  candidateStaticReportListing
) => ({
  type: FETCH_JOB_UNIVERSAL_REPORT_LISTING_SUCCESS,
  payload: candidateStaticReportListing,
});

export const fetchJobUniversalReportListingFailure = (error) => ({
  type: FETCH_JOB_UNIVERSAL_REPORT_LISTING_FAILURE,
  payload: error,
});

export const setDefaultCustomView = (defaultCustomViewRequest) => ({
  type: SET_DEFAULT_CUSTOM_VIEW,
  payload: defaultCustomViewRequest,
});

export const deleteDefaultCustomView = () => ({
  type: DELETE_DEFAULT_CUSTOM_VIEW,
});

export const fetchJobUniversalReportJobListing = (jobListingRequest) => ({
  type: FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING,
  payload: jobListingRequest,
});

export const fetchJobUniversalReportJobListingSuccess = (jobListing) => ({
  type: FETCH_JOB_UNIVERSAL_REPORT_JOB_LISTING_SUCCESS,
  payload: jobListing,
});

export const fetchJobUniversalReportJobListingFailure = (error) => ({
  type: FETCH_JOB_UNIVERSAL_REPOR_JOBT_LISTING_FAILURE,
  payload: error,
});

export const setJobDefaultCustomView = (defaultCustomViewRequest) => ({
  type: SET_JOB_DEFAULT_CUSTOM_VIEW,
  payload: defaultCustomViewRequest,
});

export const deleteJobDefaultCustomView = () => ({
  type: DELETE_JOB_DEFAULT_CUSTOM_VIEW,
});

export const fetchJobUniversalReportJobCount = (jobCountRequest) => ({
  type: FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT,
  payload: jobCountRequest,
});

export const fetchJobUniversalReportJobCountSuccess = (jobCount) => ({
  type: FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_SUCCESS,
  payload: jobCount,
});

export const fetchJobUniversalReportJobCountFailure = (error) => ({
  type: FETCH_JOB_UNIVERSAL_REPORT_JOB_COUNT_FAILURE,
  payload: error,
});
